import Axios from 'axios'
import {
    router
} from '../router'
import store from '../store/index'
import app from '../main'
import {
    Notify,
    Toast,
    Dialog
} from 'vant';
// if (window.localStorage.getItem('token')) {
//     Axios.defaults.headers.common['Authorization'] = `Bearer ` + window.localStorage.getItem('token')
// }
// http://service.aggregator.taohualian168.net
// apiUrl = 'https://api' + HOST + '.com';
// Axios.defaults.baseURL = apiUrl;
export let instance = Axios.create({
    //  baseURL: process.env.NODE_ENV === 'production' ? 'https://service.aggregator.taohualian168.net' : 'http://localhost:1000'
    // baseURL:'https://service.aggregator.taohualian168.net'
    baseURL: webconfig.path,
    timeout: 300000,
})

instance.interceptors.request.use(
    config => {
        app.$Progress.start()
        let userInfo = store.getters.userInfo;
        if (userInfo && userInfo.token && userInfo.isLogin) {
            config.headers["Authorization"] = "Bearer " + userInfo.token;
        }
        config.headers.shopId = 2;
        return config;
    },
    err => {
        return Promise.reject(err)
    }
);

// respone拦截器
instance.interceptors.response.use(
    response => {
        app.$Progress.finish()
        console.log(response.data.errors, 'http')
        if (response.data.errors === "16060") {
            router.replace({
                path: '/page',
            })
            return Promise.reject(response.data.errors)
        }
        if (response.data.errors === "17070！") {
            router.replace({
                path: '/employeeCode',
            })
            return Promise.reject(response.data.errors)
        }
        if (response.data.errors === "18080！") {
            Dialog.alert({
                message: "积分中心维护中...",
                messageAlign: "center",
                confirmButtonText: "确认",
            }).then(() => {
                // on close
            });
            return Promise.reject(response.data.errors)
        }
        if (response.data.statusCode === 500) {
            // 如果返回‘购买数量不足无法申请店员’。会员中心页面不显示申请店员按钮，不提示错误。其他正常走
            if (response.data.errors == '购买数量不足无法申请店员。' || response.data.errors == '优惠码不足，请手动领取优惠码') {
            } else {
                Toast(response.data.errors)
            }
            return Promise.reject(response.data.errors)
        }
        if (response.data.statusCode === 400) {
            let errors = JSON.stringify(response.data.errors)
            Toast(errors);
            return Promise.reject(response.data.errors)
        }
        if (response.data.statusCode === 403 || response.data.statusCode === 401) {
            Notify({
                type: 'primary',
                message: '登录过期，请重新登录'
            });
            // token失效 清除状态
            store.dispatch('buyAgentStatus', { show: false });
            if (router.currentRoute.path !== '/login') {
                router.replace({
                    path: '/login',
                    query: {
                        redirect: router.currentRoute.fullPath
                    }
                })
            }
            return Promise.reject(response.data.errors)
        } else {
            return response.data
        }
    },
    error => {
        console.log(error.message, 99999)
        app.$Progress.finish(); // 请求失败，关闭进度条
        let hasShowMsg = false;

        // ========== 新增：超时判断 ECONNABORTED ==========
        if (error.code === 'ECONNABORTED') {
            Notify({
                type: "danger",
                message: "系统维护中"
            });
            hasShowMsg = true;
        } else if (error.message == "Network Error") {
            Notify({
                type: "danger",
                message: "系统维护中"
            });
            console.log('500Network Error')
            hasShowMsg = true;
        } else {
            console.log(error.response, 158)
            if (error.response) {
                console.log(error.response, 'httpErr')
                switch (error.response.status) {
                    case 401:
                        Notify({
                            type: 'primary',
                            message: '登录过期，请重新登录'
                        });
                        store.dispatch('buyAgentStatus', { show: false });
                        if (router.currentRoute.path !== '/login') {
                            router.replace({
                                path: '/login',
                                query: {
                                    redirect: router.currentRoute.fullPath
                                }
                            })
                        }
                        hasShowMsg = true;
                        break;
                    case 404:
                        Notify({
                            type: "danger",
                            message: "系统维护中"
                        });
                        hasShowMsg = true;
                        break;
                    case 403:
                        Notify({
                            type: 'primary',
                            message: '登录过期，请重新登录'
                        });
                        store.dispatch('buyAgentStatus', { show: false });
                        if (router.currentRoute.path !== '/login') {
                            router.replace({
                                path: '/login',
                                query: {
                                    redirect: router.currentRoute.fullPath
                                }
                            })
                        }
                        hasShowMsg = true;
                        break;
                    case 400:
                        console.log('err', 400)
                        if (error.response.data.errors != undefined) {
                            Notify({
                                type: "danger",
                                message: error.response.data.errors.DomainValidations || error.response.data.errors.Name
                            });
                        } else {
                            Notify({
                                type: "danger",
                                message: error.response.data
                            });
                        }
                        hasShowMsg = true;
                        break;
                    case 500:
                        Notify({
                            type: "danger",
                            message: "系统维护中"
                        });
                        hasShowMsg = true;
                        console.log('500报错系统维护中')
                        break;
                }
            }
        }
        console.log(hasShowMsg, 'hasShowMsg')
        if (!hasShowMsg && error.response) {
            let msg = '请求异常'
            // 优先取 errors，其次才看 message，兼容两种情况
            if (error.response.data && error.response.data.errors) {
                msg = error.response.data.errors
            } else if (error.response.data && error.response.data.message) {
                msg = error.response.data.message
            }
            Toast(msg)
        }


        // 向外抛出错误，业务接口catch可以捕获
        return Promise.reject(error)
    }
)
